import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchCurrentYearForcast() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getCurrentYearForecasting`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function forecastCalculation() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/forecastCalculation`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getFutureYearForecasting() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getFutureYearForecasting`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getPastYearForecasting() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getPastYearForecasting`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function avgDealValue() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/avgDealValue`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateForecastValue(payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateForecastValue`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function commitForecast(forecastCommitYear, status, userId, payload) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/commitForecast/${forecastCommitYear}/${status}/${userId}`, payload, { headers });
        return response
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    FetchCurrentYearForcast,
    forecastCalculation,
    avgDealValue,
    getPastYearForecasting,
    getFutureYearForecasting,
    updateForecastValue,
    commitForecast,
}